// extracted by mini-css-extract-plugin
module.exports = {"packagesList":"List_packagesList__nBDLY","package":"List_package__2Tm3S"};